import BaseCell from './Cell';
import CollaboratorsCell from './CollaboratorsCell';
import DateTimeCell from './DateTimeCell';
import ObjectDueDateCell from './ObjectDueDateCell';
import ObjectLocationCell from './ObjectLocationCell';
import ObjectNameCell from './ObjectNameCell';
import ObjectStatusCell from './ObjectStatusCell';
import OptionsCell from './OptionsCell';
import EmptyCell from './EmptyCell';
import BooleanCell from './BooleanCell';

export { objectIsOverdue } from './ObjectDueDateCell';

export const Cell = Object.assign(BaseCell, {
  Collaborators: CollaboratorsCell,
  DateTime: DateTimeCell,
  ObjectDueDate: ObjectDueDateCell,
  ObjectName: ObjectNameCell,
  ObjectStatus: ObjectStatusCell,
  Options: OptionsCell,
  Location: ObjectLocationCell,
  Empty: EmptyCell,
  Boolean: BooleanCell,
});

export type { CellProps } from './Cell';
